export const routes = {
    "/:taskId/review-of-fitness": {
        title: "Action Task"
    },
};
